import { Component, ViewChild, ViewEncapsulation } from "@angular/core";
import { CropperSettings } from "ngx-img-cropper";
import { ImageService } from "../../../services/image.service";
import { BaseComponent } from "../../../common/components/base.component";
import { MatDialogRef } from "@angular/material";
import { ButtonTriggerEvent } from "../../../common/components";
import { VisitorApiService } from "../../../services/visitor.api.service";
import {
  ResizeImageModalActions,
  ResizeImageModalData,
} from "./resize.image.modal.provider";
import { ImageCropperWithPreviewComponent } from '../../../common/components/image.cropper/image.cropper.component'

@Component({
  templateUrl: "./resize.image.modal.component.html",
  styleUrls: ["./resize.image.modal.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class ResizeImageModalComponent extends BaseComponent {
  public imageData = { image: null };
  public data: ResizeImageModalData;
  public hubName: string;
  public cropperSettings: CropperSettings;
  public isImgLoaded = false;
  @ViewChild("cropper") public cropper: ImageCropperWithPreviewComponent;

  constructor(
    private dialogRef: MatDialogRef<ResizeImageModalComponent>,
    private actions: ResizeImageModalActions,
    private imageService: ImageService,
    private apiService: VisitorApiService,
    data: ResizeImageModalData
  ) {
    super();
    this.data = Object.assign({}, data);
    this.cropperSettings = this.imageService.createImageCropperSetting(
      640,
      480,
      false,
      200
    );
  }

  ngAfterViewInit() {
    this.loadImage();
  }

  private async loadImage(): Promise<void> {
    if (!this.data || !this.data.data) {
      console.log("no data in resize image modal");
      return;
    }

    // Ensure cropper is initialized
    if (!this.cropper) {
      setTimeout(() => this.loadImage(), 100);
      return;
    }

    if (this.imageService.isBase64Image(this.data.data)) {
      this.setImageToCropper(this.data.data);
    } else {
      this.apiService
        .getImageBase64(this.imageService.imageSourceUrl(this.data.data))
        .subscribe({
          next: (res) => {
            if (res && res.succeed) {
              this.setImageToCropper(res.base64);
            }
          },
          error: (error) => console.error("Error loading image:", error),
        });
    }
  }

  private setImageToCropper(base64Data: string): void {
    const image: any = new Image();
    image.onload = () => {
      this.cropper.setImage(image);
      this.imageData.image = base64Data;
      this.isImgLoaded = true;
    };
    image.src = base64Data;
  }

  public close(): void {
    if (this.actions.cancel) {
      this.actions.cancel();
    }

    this.dialogRef.close();
  }

  public async confirm(event: ButtonTriggerEvent) {
    this.actions.confirm(event, this.imageData.image);
    this.dialogRef.close();
  }
}



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/hub/resize.image.modal/resize.image.modal.component.ts